import styled from 'styled-components'

export const Cont = styled.div`
	.container {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
	}

	.button {
		padding: 12px 24px;
		font-size: 16px;
		font-weight: 500;
		color: white;
		background-color: #007bff;
		border: none;
		border-radius: 8px;
		cursor: pointer;
		transition: background-color 0.2s;
		margin: 0 auto;
	}

	.button:hover {
		background-color: #0056b3;
	}

	.button:disabled {
		background-color: #6c757d;
		cursor: not-allowed;
	}
`

const Test: React.FC = () => {
	return (
		<Cont>
			<div className="container">
				<div
					style={{
						textAlign: 'center',
					}}
				>
					<form
						method="POST"
						action={'https://api-as-uat.essilorluxottica.com/api/atol-login'}
					>
						<textarea
							name="xmlData"
							style={{
								width: '600px',
								height: '300px',
								fontFamily: 'monospace',
							}}
							placeholder="Paste your input here"
						></textarea>
						<br />
						<button className="button" type="submit">
							Atol Login Simulator
						</button>
					</form>
				</div>
			</div>
		</Cont>
	)
}

export default Test
